module.exports = __webpack_public_path__ + "img/guizhouHints_9.e8bd565a.jpg";